import React from 'react';
import styles from './InfoCard.module.css';

const InfoCard = ({ title, data }) => {
  if (!data) return null; // Don't render if there's no data

  return (
    <div className={styles.card}>
      <h2 className={styles.title}>{title}</h2>
      <div className={styles.content}>
        {Object.entries(data).map(([key, value]) => (
          <div key={key} className={styles.row}>
            <span className={styles.key}>{key}</span>
            <span className={styles.value}>{value}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default InfoCard;